// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CsrRepModel } from "@store/Framework/Types/ApiModels";
import ContactUsState from "@store/Framework/Store/Greif/Pages/ContactUs/ContactUsState";
import { Draft } from "immer";

const initialState: ContactUsState = {
    resetValues: false,
    plantFieldValues: {
        address: "",
        cellPhone: "",
        email: "",
        firstName: "",
        lastName: "",
        officePhone: "",
        role: "",
        isDefaultPlant: false,
        plant: "",
        plantDisplayName: "",
    },
};

const actions = {
    "Greif/Pages/ContactUs/ResetValues": (draft: Draft<ContactUsState>) => {
        draft.resetValues = !draft.resetValues;
    },
    "Greif/Pages/ContactUs/ClearForm": (draft: Draft<ContactUsState>) => {
        draft.shipTo = "";
        draft.soldTo = "";
        draft.customerNumber = "";
    },
    "Greif/Pages/ContactUs/SetPlantFieldValue": (draft: Draft<ContactUsState>, action: { value: CsrRepModel }) => {
        draft.plantFieldValues = action.value;
    },
    "Greif/Pages/ContactUs/SetSoldToValue": (draft: Draft<ContactUsState>, action: { value: string }) => {
        draft.soldTo = action.value;
    },
    "Greif/Pages/ContactUs/SetShipToValue": (draft: Draft<ContactUsState>, action: { value: string }) => {
        draft.shipTo = action.value;
    },
    "Greif/Pages/ContactUs/SetCustomerNumber": (draft: Draft<ContactUsState>, action: { value: string }) => {
        draft.customerNumber = action.value;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifContactUsPageReducer = Parameters<typeof reducer>[1];
export default reducer;
